import {
  Box,
  Div,
  EditPenIcon,
  H5,
  Icon,
  Img,
  ImagePlaceholderCircle,
  ImagePlaceholderIcon,
  P,
  centsToDollars,
  formatter,
  lightTheme,
} from '@vgrubs/components';
import { ItemListImage } from 'components/src/adminPages/Menu/MenyStyled';
import { BTMenuItemResponse } from 'components/src/types/brand.types';
import { Dispatch, SetStateAction } from 'react';

/** One item of the submitted brand menu: image, name, chosen price, and the edit pen. */
export const BrandMenuItem = ({
  item,
  index,
  setEditItemModal,
}: {
  item: BTMenuItemResponse;
  index: number;
  setEditItemModal: Dispatch<SetStateAction<BTMenuItemResponse | null>>;
}) => {
  return (
    <Box key={index} $flex $alignCenter $between>
      <Div $width="100%" $flex $alignCenter $gap="16px">
        <Div $flex>
          {item.imageUrl ? (
            <ItemListImage>
              <Img
                alt=""
                height="50px"
                src={
                  item.imageUrl ? item.imageUrl : (ImagePlaceholderIcon as any)
                }
              />
            </ItemListImage>
          ) : (
            <ImagePlaceholderCircle />
          )}
        </Div>
        <Div $flex $column $gap="2px">
          <P $mb="0">{item.name}</P>
          <H5 $m="0" $color={lightTheme.primary}>
            {formatter.format(centsToDollars(item.chosenPrice ?? 0))}
          </H5>
        </Div>
      </Div>
      <Div $flex $alignCenter $between $gap="16px" $gapSM="8px">
        <Icon $shadow $pointer onClick={() => setEditItemModal?.(item)}>
          <EditPenIcon />
        </Icon>
      </Div>
    </Box>
  );
};
